import SGeolocation2 from "../../Components/SGeolocation2";
import MDLAbstract from "../MDLAbstract";
import { EventListener } from "./types";
import { Position } from "../../Components/SGeolocation2/type";
import { request, PERMISSIONS } from "react-native-permissions";
import { Platform } from "react-native";

export default class geolocation extends MDLAbstract<EventListener> {

    lastPosition: Position | null = null;
    async componentDidMount() {
        try {
            console.log("Iniciando geolocation");
            await this.getCurrentPosition();
            this.dispatchEvent({ type: "ready" });
        } catch (error) {
            console.error(error);
        }


    }


    getPermission = async () => {

        const permission: any = Platform.select({
            "android": PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION,
            "ios": PERMISSIONS.IOS.LOCATION_WHEN_IN_USE,
            "web": null
        });
        const result = await request(permission);
        if (result !== 'granted') {
            console.error(`Permission ${permission} not granted.`);
            throw new Error(`Permission ${permission} not granted.`);
        }
        return true;
    }

    getCurrentPosition = async () => {

        try {
            return;
            // await this.getPermission();

        } catch (error) {
            console.error("Error getting permission for geolocation", error);
        }
        const resp = await SGeolocation2.getCurrentPosition({
            enableHighAccuracy: true,
            maximumAge: 10000,
            timeout: 15000
        })
        this.lastPosition = resp;
        return resp as Position;
    }
}